import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-8 px-4 text-center text-sm border-t border-gray-800" data-id="element-71">
      <div className="max-w-3xl mx-auto space-y-4" data-id="element-72">
        <p className="text-blue-400 font-bold mb-2" data-id="element-73">
          💙 "Los mejores recuerdos de la infancia no cuestan dinero, cuestan
          tiempo y atención."
        </p>
        <p data-id="element-74">
          💙 100 CITAS CON MI HIJA — © 2026 — Todos los derechos reservados.
        </p>
        <p className="text-xs text-gray-500" data-id="element-75">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
        <div className="flex justify-center gap-4 pt-2" data-id="element-76">
          <a href="#" className="hover:text-white transition-colors" data-id="element-77">
            Privacidad
          </a>
          <span data-id="element-78">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-79">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}